import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";

export interface GroupInfoBadgeProps {
  name: string;
  channelsProcessed: number;
  channelsTotal: number;
  warning?: string;
}

const GroupInfoBadge = ({
  name,
  channelsProcessed,
  channelsTotal,
  warning,
}: GroupInfoBadgeProps) => {
  const isComplete = channelsProcessed === channelsTotal && !warning;
  const channelsLabel =
    channelsProcessed === channelsTotal
      ? `${channelsTotal}`
      : `${channelsProcessed} из ${channelsTotal}`;

  return (
    <Tooltip title={warning} open={warning ? undefined : false}>
      <Tag
        icon={isComplete ? <CheckCircleOutlined /> : <ExclamationCircleOutlined />}
        color={isComplete ? "success" : "warning"}
        style={{ margin: 0, marginBottom: 12, padding: "4px 12px", fontSize: 14 }}
      >
        Агрегация по группе <strong>{name}</strong>, каналов: {channelsLabel}
      </Tag>
    </Tooltip>
  );
};

export default GroupInfoBadge;
